import { silsilahAdminApiSource } from '@/projects/silsilah/datasource/adminApiSource';
import type { User } from '@/models/model.type';

export const silsilahAdminAuthRepository = {
  login: (googleToken: string) => silsilahAdminApiSource.login(googleToken),

  async profile(token: string): Promise<User> {
    const profile = await silsilahAdminApiSource.profile(token);
    return {
      id: profile.id,
      email: profile.email,
      fullName: profile.name,
      role: profile.roles.includes('ADMIN') ? 'admin' : 'user',
      roles: profile.roles,
      avatarUrl: null,
      createdAt: new Date(0),
      isActive: true,
    };
  },
};
